import { createFileRoute } from "@tanstack/react-router";

import { SchedulesPage } from "@/components/paid-media/schedules/schedules-page";

export const Route = createFileRoute("/dashboard/paid-media/_layout/schedules")({
  component: SchedulesPage,
});
